import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { style: {"margin-bottom":"16px"} }, "通道域名管理", -1)
const _hoisted_2 = { style: {"display":"flex","align-items":"center","margin-bottom":"16px"} }
const _hoisted_3 = ["onClick"]

import { ref, onMounted, watch } from "vue";
import { message, Modal } from "ant-design-vue";
import XTable from "@/components/XATable.vue";
import {
  channelDomainList,
  channelDomainCreate,
  channelDomainDel,
} from "@/api/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelDomain',
  props: {
  isRefresh: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const domainInput = ref("");
const tableData = ref([]);
const loading = ref(false);
const props = __props;
const columns = [
  { title: "ID", dataIndex: "id", key: "id", width: 80 },
  { title: "域名", dataIndex: "hostName", key: "hostName" },
  {
    title: "添加时间",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 180,
    isAllTime: true,
  },
  { title: "操作", dataIndex: "action", key: "action", width: 100 },
];

watch(
  () => props.isRefresh,
  (cur, old) => {
    fetchTableData();
  }
);

const fetchTableData = async () => {
  loading.value = true;
  try {
    const res = await channelDomainList({});
    tableData.value = res.data.records || [];
  } catch (e) {
    message.error("获取域名列表失败");
  } finally {
    loading.value = false;
  }
};

const addDomain = async () => {
  if (!domainInput.value) {
    message.warning("请输入域名");
    return;
  }
  const params = {
    url: domainInput.value, // 可选，或补充输入
  };
  const res = await channelDomainCreate(params);
  if (res.code === "200") {
    message.success("添加成功");
    domainInput.value = "";
    fetchTableData();
  } else {
    message.error(res.msg);
  }
};

const deleteDomain = (record: any) => {
  Modal.confirm({
    title: "确认删除该域名？",
    content: `域名：${record.hostName}`,
    okText: "确定",
    cancelText: "取消",
    onOk: async () => {
      const params = { id: record.id };
      const res = await channelDomainDel(params);
      if (res.code === "200") {
        message.success("删除成功");
        fetchTableData();
      } else {
        message.error(res.msg);
      }
    },
  });
};

onMounted(() => {
  fetchTableData();
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_input, {
        value: domainInput.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((domainInput).value = $event)),
        placeholder: "输入域名，如：example.com",
        style: {"width":"220px","margin-right":"8px"}
      }, null, 8, ["value"]),
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: addDomain
      }, {
        default: _withCtx(() => [
          _createTextVNode("添加域名")
        ]),
        _: 1
      })
    ]),
    _createVNode(XTable, {
      columns: columns,
      "data-source": tableData.value,
      loading: loading.value,
      rowKey: "id",
      bordered: ""
    }, {
      action: _withCtx(({ record }) => [
        _createElementVNode("a", {
          onClick: ($event: any) => (deleteDomain(record))
        }, "删除", 8, _hoisted_3)
      ]),
      _: 1
    }, 8, ["data-source", "loading"])
  ]))
}
}

})